import { render, staticRenderFns } from "./ConsultForm.vue?vue&type=template&id=10b97c74&scoped=true"
import script from "./ConsultForm.vue?vue&type=script&lang=js"
export * from "./ConsultForm.vue?vue&type=script&lang=js"
import style0 from "./ConsultForm.vue?vue&type=style&index=0&id=10b97c74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b97c74",
  null
  
)

export default component.exports